
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { saveMixin } from "@/mixins/saveMixin";
import { contentMixin } from "@/components/template-transfer-pc/template/mixins/contentMixin";
import MainHeader from "@/components/main-header.vue";
import TemplateTransfer from "@/components/template-transfer-pc/template/template-transfer.vue";
import {
  GetTemDetail,
  PostCepingContent,
  GetPatientDetail,
  GetContentDetail,
  EditContent,
} from "@/request/common";
import { getCurrentTime } from "@/utils/base";
import { IfEmpty } from "@/components/template-transfer-pc/template/common";
import BatchPrinting from "@/components/batch-printing.vue";
import TemplateContent from "@/components/template-transfer-pc/template/template-content.vue";
@Component({
  components: {
    MainHeader,
    TemplateTransfer,
    BatchPrinting,
    TemplateContent,
  },
})
export default class Name extends mixins(saveMixin, contentMixin) {
  private type: any = "";
  private patient_id: any = "";
  private navData: any = [];
  private cNav: any = {};
  private template: any = {};
  private patient: any = {};
  private disabledDate: any = this.endDate();
  private ifShowBatchPrinting: any = false;

  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private goReport() {
    this.$router.push({
      path: "/main/report/ceping-report",
      query: {
        ids: JSON.stringify([this.data.id]),
      },
    });
  }
  private changeNav(item: any) {
    if (this.ifPlay) {
      this.$message.warning("请先关闭语音播放");
      return;
    }
    if (this.ifCompose) {
      this.changeData = item;
      this.ifShowSaveConfirm = true;
      this.leaveType = "切换";
    } else {
      this.cNav = item;
      if (item.content_id) {
        this.getData();
      } else {
        this.getTemplate();
      }
    }
  }
  private updateContent(e: any) {
    this.data = e;
  }
  leaveChange(item: any) {
    this.changeNav(item);
  }
  private edit() {
    this.$store.commit("updateIfCompose", true);
  }
  private updateWholeTem(e: any) {
    this.data.data = e;
    this.$forceUpdate();
  }
  save() {
    return new Promise((resolve, reject) => {
      (this.$refs.templateContent as any).savePre().then((res: any) => {
        if (res) {
          const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
          });
          if (this.cNav.content_id) {
            EditContent(this, this.cNav.content_id, this.data, loading).then(
              (res: any) => {
                this.$message.success("保存成功！");
                this.$store.commit("updateIfCompose", false);
                this.getData();
                resolve(true);
              }
            );
          } else {
            const params: any = {
              patient: this.patient.id,
              template: this.cNav,
              data: this.data.data,
              collect_time: this.data.collect_time,
              related_type: this.type,
            };
            PostCepingContent(this, params, loading).then((res: any) => {
              this.$message.success("保存成功！");
              this.$store.commit("updateIfCompose", false);
              this.cNav.content_id = res.data.id;
              const index: any = this.navData.findIndex((val: any) => {
                return val.id == this.cNav.id;
              });
              this.navData[index].content_id = res.data.id;
              this.$forceUpdate();
              this.getData();
              resolve(true);
            });
          }
        }
      });
    });
  }

  private getTemplate() {
    if (!this.cNav.id) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemDetail(this, this.cNav.id, loading)
      .then((res: any) => {
        loading.close();
        this.template = res.data;
        const d: any = JSON.parse(JSON.stringify(res.data));
        d.patient = this.patient;
        d.data = d.fields;
        d.template = res.data;
        d.collect_time = getCurrentTime("yyyy-MM-dd HH:mm:ss");
        this.data = d;
      })

      .catch(() => {
        loading.close();
      });
  }
  private getData() {
    if (!this.cNav.content_id) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetContentDetail(this, this.cNav.content_id, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.scrollToTop();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getPatientData() {
    if (!this.patient_id) {
      return;
    }
    GetPatientDetail(this, this.patient_id).then((res: any) => {
      this.patient = res.data;
    });
  }

  private formatTooltio(val: any) {
    return val;
  }
  private jifenChange(tIndex: any) {
    if (this.ifPlay) {
      // 如果是最后一题，则不需要切换到下一题
      // 后面的题目没有hide==false或者type==段落标题或者type==主标题都算作当前题目为最后一题
      let isLast = true;
      for (let i = tIndex + 1; i < this.data.data.length; i++) {
        if (
          !this.data.data[i].hide &&
          this.data.data[i].type != "段落标题" &&
          this.data.data[i].type != "主标题"
        ) {
          isLast = false;
          break;
        }
      }
      if (isLast) {
        this.stopPlayAudio();
      } else {
        this.playAudio(tIndex + 1);
      }
    }
  }
  mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.patient_id) {
      this.patient_id = this.$route.query.patient_id;
      this.getPatientData();
    }
    if (this.$route.query.data) {
      this.navData = JSON.parse(this.$route.query.data as any);
      this.cNav = this.navData[0];
      this.getTemplate();
    }
    // if (this.$route.query.content_id) {
    //   this.content_id = this.$route.query.content_id;
    //   this.getData();
    // }
  }
}
